import { useState, useLayoutEffect, useEffect } from "react";

import { useState as useReducerState } from "src/hooks/state";

export function useWindowSize() {
  const [size, setSize] = useState(window.innerWidth || 0);

  useLayoutEffect(() => {
    function updateSize() {
      setSize(window.innerWidth);
    }

    window.addEventListener("resize", updateSize);
    updateSize();

    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return size;
}

/**
 * Returns true if current window size is mobile size
 */
export function useIsMobileWidth(limitSize?: number) {
  const windowWidth = useWindowSize();
  const defaultMobileSize = 640;
  const size = limitSize ?? defaultMobileSize;
  return windowWidth < size;
}

const SIMPLE_COMMON_BREAKPOINTS = {
  DESKTOP: 1024,
  TABLET: 768,
  PHONE: 480
};

const DEFAULT_STATE = {
  isPhone: false,
  isTablet: false,
  isDesktop: false
};
export function useResponseSize() {
  const [responseSize, setResponsiveSize] = useReducerState(DEFAULT_STATE);
  const size = useWindowSize();

  useEffect(() => {
    if (size >= SIMPLE_COMMON_BREAKPOINTS.DESKTOP) {
      setResponsiveSize({ ...DEFAULT_STATE, isDesktop: true });
    } else if (size >= SIMPLE_COMMON_BREAKPOINTS.TABLET) {
      setResponsiveSize({ ...DEFAULT_STATE, isTablet: true });
    } else {
      setResponsiveSize({ ...DEFAULT_STATE, isPhone: true });
    }
  }, [size]);

  return responseSize;
}
